export default __webpack_public_path__ + "static/media/challenges2.a3cd334c.jpg";